import { gql } from 'graphql-request';
import { z } from 'zod';
import { BlockQueryCollection, DatoSeoQuery, DatoSeoValidation, Query } from '@queries/datoCMS';
import { AssetBlockQuery } from '@blocks/asset/AssetBlockQuery';
import { ServiceListBlockQuery } from '@blocks/serviceList/ServiceListBlockQuery';
import { AssetWithContentBlockQuery } from '@blocks/assetWithContent/AssetWithContentBlockQuery';
import { EmployeeListBlockQuery } from '@blocks/employeeList/EmployeeListBlockQuery';
import { CaseListBlockQuery } from '@blocks/caseList/CaseListBlockQuery';
import { AccordionBlockQuery } from '@blocks/accordion/AccordionBlockQuery';
import { FeaturedServiceBlockQuery } from '@blocks/featuredService/FeaturedServiceBlockQuery';
import { BreakerBlockQuery } from '@blocks/breaker/BreakerBlockQuery';
import { BlogListBlockQuery } from '@blocks/blogList/BlogListBlockQuery';
import { DescriptionBlockQuery } from '@blocks/description/DescriptionBlockQuery';
import { AssetWithDescriptionBlockQuery } from '@blocks/assetWithDescription/AssetWithDescriptionBlockQuery';

// Register blocks
const ContentBlocksQuery = new BlockQueryCollection([
	DescriptionBlockQuery,
	ServiceListBlockQuery,
	EmployeeListBlockQuery,
	AccordionBlockQuery,
	AssetBlockQuery,
	AssetWithDescriptionBlockQuery,
	BreakerBlockQuery,
	AssetWithContentBlockQuery,
	FeaturedServiceBlockQuery,
	CaseListBlockQuery,
	BlogListBlockQuery
]);

const contentValidation = z
	.object({
		headline: z.string(),
		content: ContentBlocksQuery.validation
	})
	.merge(DatoSeoValidation);

export const ContentPageQuery = (slug: string) => {
	return new Query(
		gql`
			query ContentPage {
				contentPage(filter: {slug: {eq: "${slug}"}}) {
					headline
					content {
						${ContentBlocksQuery}
					}
					${DatoSeoQuery}
				}
			}
		`,
		z.object({
			contentPage: contentValidation.nullish()
		})
	);
};

export type ContentPageData = z.infer<typeof contentValidation>;
export type ContentBlocksData = z.infer<typeof ContentBlocksQuery.validation>;
